//for refactoring
//separate file per type to minize data import not used in page
//constants - documentTypes for example

const common_data = {
    devices_list_os: [
        {name: 'Android', description: 'Android'},
        {name: 'IOS', description: 'IOS'},
        {name: 'Windows', description: 'Windows'},
        {name: 'Mobile', description: 'Mobile'},
        {name: 'Google', description: 'Google'},
    ],
    devices_list: [
        {name: 'Acer', description: 'Acer'},
        {name: 'Asus', description: 'Asus'},
        {name: 'Blackberry', description: 'Blackberry'},
        {name: 'Dingding', description: 'Dingding'},
        {name: 'HTC', description: 'HTC'},  
        {name: 'Huawei', description: 'Huawei'},
        {name: 'iPad', description: 'iPad'},
        {name: 'iPhone', description: 'iPhone'},
        {name: 'iPod', description: 'iPod'},
        {name: 'KFAPWI', description: 'KFAPWI'},
        {name: 'Lenovo', description: 'Lenovo'},   
        {name: 'Microsoft', description: 'Microsoft'},        
        {name: 'Motorola', description: 'Motorola'},  
        {name: 'Nexus', description: 'Nexus'}, 
        {name: 'Nokia', description: 'Nokia'},
        {name: 'Oppo', description: 'Oppo'},   
        {name: 'Pixel', description: 'Pixel'},
        {name: 'Realme', description: 'Realme'},  
        {name: 'SAMSUNG', description: 'SAMSUNG'}, 
        {name: 'SM-', description: 'SAMSUNG'}, 
        {name: 'Sony', description: 'Sony'},
        {name: 'Toshiba', description: 'Toshiba'},   
        {name: 'Vivo', description: 'Vivo'},
        {name: 'Wechat', description: 'Wechat'},
        {name: 'Xiaomi', description: 'Xiaomi'},  
    ],
    headers_timeoff: [
        {text: 'Date',align: 'left',value: 'code',width: '10%', sortable:false},
        {text: 'Hours',align: 'left',value: 'duration',width: '15%', sortable:false},
        {text: 'Type',align: 'left',value: 'type',width: '25%', sortable:false},
        {text: 'Status',align: 'left',value: 'status',width: '15%', sortable:false},
        {text: 'Remarks',align: 'left',value: 'remarks',sortable:false}
    ],
    headers_attendance_mobile: [
        {text: 'Action',align: 'left',value: 'code',width: '25%', sortable:false},
        {text: 'Time',align: 'left',value: 'code',width: '25%', sortable:false},        
        {text: 'Pic',align: 'left',value: 'hours',width: '15%', sortable:false},
        {text: 'Device',align: 'left',value: 'hours',width: '30%', sortable:false},
    ],
    headers_attendance: [
        {text: 'Action',align: 'left',value: 'code',width: '15%', sortable:false},
        {text: 'Time',align: 'left',value: 'code',width: '15%', sortable:false},
        {text: 'Pic',align: 'left',value: 'hours',width: '20%', sortable:false},
        {text: 'Device',align: 'left',value: 'hours',width: '25%', sortable:false},
        {text: 'Remarks',align: 'left',value: 'hours',width: '25%', sortable:false},
    ],
    headers_attendance_new: [
        {text: 'Action',align: 'left',value: 'code',width: '15%', sortable:false},
        {text: 'Time',align: 'left',value: 'code',width: '15%', sortable:false},
        {text: 'Pic',align: 'left',value: 'hours',width: '15%', sortable:false},
        {text: 'Device',align: 'left',value: 'hours',width: '25%', sortable:false},
        // {text: 'Location',align: 'left',value: 'description',width: '30%', sortable:false},
        {text: 'Remarks',align: 'left',value: 'hours',width: '25%', sortable:false}
    ],
    headers_attendance_new_mobile: [
        {text: 'Time',align: 'left',value: 'code',width: '30%', sortable:false},
        {text: 'Pic',align: 'left',value: 'hours',width: '30%', sortable:false},
        {text: 'Device',align: 'left',value: 'hours',width: '40%', sortable:false},
        // {text: 'Location',align: 'left',value: 'description',width: '30%', sortable:false},
    ], 
    headers_timeoff: [
        {text: 'Date',align: 'left',value: 'code',width: '10%', sortable:false},
        {text: 'Hours',align: 'left',value: 'duration',width: '15%', sortable:false},
        {text: 'Type',align: 'left',value: 'type',width: '25%', sortable:false},
        {text: 'Status',align: 'left',value: 'status',width: '15%', sortable:false},
        {text: 'Remarks',align: 'left',value: 'remarks',sortable:false}
    ],
    headers_tasks: [
        {text: 'Project',align: 'left',value: 'code',width: '30%', sortable:false},
        {text: 'Task',align: 'left',value: 'description',width: '30%', sortable:false},
        {text: 'Hours',align: 'left',value: 'hours',width: '10%', sortable:false},
        {text: 'Status',align: 'left',value: 'hours',width: '10%', sortable:false},
        {text: 'Remarks',align: 'left',value: 'hours',width: '10%', sortable:false}
    ],
    headers_overtime: [        
        {text: 'Duration',align: 'left',value: '',width: '15%', sortable:false},
        {text: 'Total Hours',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Break Time (mins)',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Chargeable Hours',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Charging Type',align: 'left',value: '',width: '15%', sortable:false},
        // {text: 'Project',align: 'left',value: '',width: '15%', sortable:false},
        // {text: 'Task',align: 'left',value: '',width: '15%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '15%', sortable:false},               
    ],
    headers_attendance_corrections: [
        {text: 'Date',align: 'left',value: '', width: '15%', sortable:false},
        {text: 'Clock-In',align: 'left',value: '', width: '15%', sortable:false},   
        {text: 'Clock-Out',align: 'left',value: '', width: '15%', sortable:false},              
        {text: 'Filed On',align: 'left',value: 'createdOn',width: '15%',sortable:false},
        {text: 'Status',align: 'left',value: 'status',width: '15%',sortable:false},
        {text: 'Remarks',align: 'left',value: 'remarks',width: '25%',sortable:false}
    ],
    headers_leaves: [
        {text: 'Type',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Annual Credits',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Cash Conversion Limit',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Carry-Over Limit',align: 'left',value: '',width: '5%', sortable:false},
        {text: 'Pro-Rated',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '10%', sortable:false},
    ],
    header_compensation: [
        {text: 'Pay Grade',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Monthly Basic Salary',align: 'right',value: '',width: '10%', sortable:false},
        {text: 'Annual Basic Salary',align: 'right',value: '',width: '10%', sortable:false},
        {text: 'OT Pay Eligible',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'ND Pay ELigible',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Effective Date',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
    ],
    header_compensation_hourly: [
        {text: 'Pay Grade',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Hourly Rate',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'OT Pay Eligible',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'ND Pay Eligible',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Effective Date',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
    ],    
    header_deminimis: [
        {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
        {text: 'Payout On',align: 'left',value: '',width: '25%', sortable:false},
        {text: 'Payout Schedule',align: 'left',value: '',width: '5%', sortable:false},
        {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
    ],
    headers_otherbenefits: [
        {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
        {text: 'Payout On',align: 'left',value: '',width: '20%', sortable:false},
        {text: 'Payout Schedule',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Rate',align: 'left',value: '',width: '10%', sortable:false},
        {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},        
        {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
    ],
    headers_13Month: [
        {text: 'Payout On',align: 'left',value: '', width:'25%', sortable:false},
        {text: 'Rate',align: 'left',value: '', width:'15%', sortable:false},
        {text: 'Payout Schedule',align: 'left',value: '',width: '20%', sortable:false},
        {text: 'Remarks',align: 'left',value: '', width:'20%', sortable:false},
        {text: 'Status',align: 'left',value: '', width:'20%', sortable:false}
    ],
    headers_fringe: [
        {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
        {text: 'Payout On',align: 'left',value: '',width: '25%', sortable:false},
        {text: 'Payout Schedule',align: 'left',value: '',width: '5%', sortable:false},
        {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
        {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
    ],
    payout_modes: [
        {payoutMode: 1, description: "First cutoff"},
        {payoutMode: 2, description: "Second cutoff"},
        {payoutMode: 3, description: "Half per cutoff"},
        {payoutMode: 4, description: "Once a month"}
    ],
    months: [
        {month: "Every Month", value: 20},
        {month: "January", value: 1},
        {month: "February", value: 2},
        {month: "March", value: 3},
        {month: "April", value: 4},
        {month: "May", value: 5},
        {month: "June", value: 6},
        {month: "July", value: 7},
        {month: "August", value: 8},
        {month: "September", value: 9},
        {month: "October", value: 10},
        {month: "November", value: 11},
        {month: "December", value: 12}
    ],  
    loading_main: [
        {name:'comp_a',value:false},
        {name:'comp_r',value:false},
        {name:'comp_f',value:false},
        {name:'leave_a',value:false},
        {name:'leave_r',value:false},
        {name:'leave_f',value:false},
        {name:'leave_a_d',value:false},
        {name:'leave_r_d',value:false},
        {name:'leave_u_d',value:false},
        {name:'deminimis_a',value:false},
        {name:'deminimis_r',value:false},
        {name:'deminimis_f',value:false},
        {name:'deminimis_r_d',value:false},
        {name:'deminimis_u_d',value:false},
        {name:'deminimis_a_d',value:false},
        {name:'other_a',value:false},
        {name:'other_r_d',value:false},
        {name:'other_r',value:false},
        {name:'other_f',value:false},
        {name:'other_a_d',value:false},
        {name:'other_u_d',value:false},
        {name:'fringe_a',value:false},
        {name:'fringe_r',value:false},
        {name:'fringe_f',value:false},
        {name:'fringe_r_d',value:false},
        {name:'fringe_u_d',value:false},
        {name:'fringe_a_d',value:false},
        {name:'pdf',value:false},
    ],

    //transferred to constants/deduction-types.js, update other references
    deduction_modes: [
        {deductionMode: 1, description: 'First cutoff'},
        {deductionMode: 2, description: 'First cutoff'},
        {deductionMode: 3, description: 'Half per cutoff'},
        {deductionMode: 4, description: 'Monthly'},
    ],

    //TODO check if all references have been updated to point to @/constants/status-codes.js, 
    //then this can be deleted
    status_codes: [
        {statusCode: null, statusDescription: 'Undefined', color: '', buttonColor: ''},
        {statusCode: 0, statusDescription: 'Not Available', color: '', buttonColor: 'orange'},
        {statusCode: 1, statusDescription: 'Created', color: '', buttonColor: 'primary'},
        {statusCode: 2, statusDescription: 'For Review', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 3, statusDescription: 'Approved', color: 'green--text', buttonColor: 'green darken-2'},
        {statusCode: 4, statusDescription: 'Rejected', color: 'red--text', buttonColor: 'red'},
        {statusCode: 5, statusDescription: 'Processed', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 6, statusDescription: 'Fund Transferred', color: '', buttonColor: ''},
        {statusCode: 7, statusDescription: 'Fund Released', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 8, statusDescription: 'Published', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 9, statusDescription: 'Adjustments Processed', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 10, statusDescription: 'Pending Payment', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 11, statusDescription: 'Installment Paid', color: 'green--text', buttonColor: 'green'},
        {statusCode: 12, statusDescription: 'Cancelled', color: '', buttonColor: 'grey'},
        {statusCode: 13, statusDescription: 'Deleted', color: 'red--text', buttonColor: 'red'},
        {statusCode: 14, statusDescription: 'Open', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 15, statusDescription: 'Frozen', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 16, statusDescription: 'Closed', color: 'green--text', buttonColor: 'green'},
        {statusCode: 17, statusDescription: 'Hiring Process', color: '', buttonColor: ''},
        {statusCode: 18, statusDescription: 'Contract Signed', color: '', buttonColor: ''},
        {statusCode: 19, statusDescription: 'Active', color: 'green--text', buttonColor: ''},
        {statusCode: 20, statusDescription: 'Talent Pool', color: '', buttonColor: ''},
        {statusCode: 21, statusDescription: 'Resigned', color: 'red--text', buttonColor: ''},
        {statusCode: 22, statusDescription: 'Permanent', color: '', buttonColor: ''},
        {statusCode: 23, statusDescription: 'Consultant', color: '', buttonColor: ''},
        {statusCode: 24, statusDescription: 'Contractor', color: '', buttonColor: ''},
        {statusCode: 25, statusDescription: 'Under Revision', color: 'orange--text', buttonColor: ''},
        {statusCode: 26, statusDescription: 'For Deletion', color: 'red--text', buttonColor: ''},
        {statusCode: 27, statusDescription: 'For Deactivation', color: 'red--text', buttonColor: ''},
        {statusCode: 28, statusDescription: 'Deactivated', color: 'grey--text', buttonColor: ''},
        {statusCode: 29, statusDescription: 'Credited', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 30, statusDescription: 'Upload Validated', color: '', buttonColor: 'primary'},
        {statusCode: 31, statusDescription: 'Upload Saved', color: '', buttonColor: 'green darken-2'},
        {statusCode: 32, statusDescription: 'Not Started', color: '', buttonColor: ''},
        {statusCode: 33, statusDescription: 'In Progress', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 34, statusDescription: 'Completed', color: 'green--text', buttonColor: 'green darken-2'},
        {statusCode: 35, statusDescription: 'On Hold', color: 'red--text', buttonColor: 'red'},
        {statusCode: 36, statusDescription: 'Probationary', color: '', buttonColor: ''},
        {statusCode: 37, statusDescription: 'Regular', color: '', buttonColor: ''},
        {statusCode: 38, statusDescription: 'Single', color: '', buttonColor: ''},
        {statusCode: 39, statusDescription: 'Married', color: '', buttonColor: ''},
        {statusCode: 40, statusDescription: 'Widowed', color: '', buttonColor: ''},
        {statusCode: 41, statusDescription: 'Divorced', color: '', buttonColor: ''},
        {statusCode: 42, statusDescription: 'Separated', color: '', buttonColor: ''},
        {statusCode: 43, statusDescription: 'Annulled', color: '', buttonColor: ''},
        {statusCode: 44, statusDescription: 'Draft', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 45, statusDescription: 'Issued', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 46, statusDescription: 'Overdue', color: 'red--text', buttonColor: 'red'},
        {statusCode: 47, statusDescription: 'Paid in Full', color: 'green--text', buttonColor: 'green darken-2'},
        {statusCode: 48, statusDescription: 'Terminated', color: 'red--text', buttonColor: ''},
        {statusCode: 49, statusDescription: 'Payment For Review', color: 'primary--text', buttonColor: 'primary'},
        {statusCode: 50, statusDescription: 'Prospecting', color: 'blue--text text--darken-2', buttonColor: 'blue lighten-1'},
        {statusCode: 51, statusDescription: 'Contacted', color: 'amber--text text--darken-2', buttonColor: 'amber lighten-1'},
        {statusCode: 52, statusDescription: 'Qualified', color: 'amber--text text--darken-3', buttonColor: 'amber darken-1'},
        {statusCode: 53, statusDescription: 'Product Demo Scheduled', color: 'indigo--text text--darken-2', buttonColor: 'indigo lighten-1'},
        {statusCode: 54, statusDescription: 'Product Demo Completed', color: 'indigo--text text--darken-3', buttonColor: 'indigo darken-1'},
        {statusCode: 55, statusDescription: 'Evaluating', color: 'deep-purple--text text--darken-2', buttonColor: 'deep-purple lighten-1'},
        {statusCode: 56, statusDescription: 'Negotiating', color: 'deep-purple--text text--darken-3', buttonColor: 'deep-purple darken-1'},
        {statusCode: 57, statusDescription: 'Active Customer', color: 'green--text text--darken-2', buttonColor: 'green darken-2'},
        {statusCode: 58, statusDescription: 'Dormant', color: 'grey--text text--darken-3', buttonColor: 'grey darken-3'},
        {statusCode: 59, statusDescription: 'Lost', color: 'grey--text text--darken-2', buttonColor: 'grey darken-3'},
        {statusCode: 60, statusDescription: 'Disqualified', color: 'grey--text text--darken-3', buttonColor: 'grey darken-4'},
        {statusCode: 61, statusDescription: 'Former Customer', color: 'red--text text--darken-2', buttonColor: 'red darken-2'},
        {statusCode: 62, statusDescription: 'Incomplete', color: 'orange--text', buttonColor: 'warning'},
        {statusCode: 63, statusDescription: 'Needs Attention', color: 'red--text', buttonColor: 'red'},
        {statusCode: 64, statusDescription: 'Pending', color: 'grey--text', buttonColor: 'grey'},
        {statusCode: 65, statusDescription: 'Partially Approved', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 66, statusDescription: 'Suspended', color: 'red--text', buttonColor: 'red'},
        {statusCode: 67, statusDescription: 'On Maternity Leave', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 68, statusDescription: 'On Sick Leave', color: 'orange--text', buttonColor: 'orange'},
        {statusCode: 69, statusDescription: 'On-site', color: '', buttonColor: ''},
        {statusCode: 70, statusDescription: 'Remote', color: '', buttonColor: ''},
        {statusCode: 71, statusDescription: 'Hybrid', color: '', buttonColor: ''},
        {statusCode: 72, statusDescription: 'Field-Based', color: '', buttonColor: ''},
        {statusCode: 73, statusDescription: 'Inbound', color: '', buttonColor: ''},
        {statusCode: 74, statusDescription: 'Outbound', color: '', buttonColor: ''},
        {statusCode: 75, statusDescription: 'Customer Support', color: '', buttonColor: ''},
        {statusCode: 76, statusDescription: 'Back Office Support', color: '', buttonColor: ''},
        {statusCode: 77, statusDescription: 'Direct Care', color: '', buttonColor: ''},
        {statusCode: 78, statusDescription: 'Ancillary', color: '', buttonColor: ''},
        {statusCode: 79, statusDescription: 'Technical Delivery', color: '', buttonColor: ''},
        {statusCode: 80, statusDescription: 'Quality Assurance', color: '', buttonColor: ''},
        {statusCode: 81, statusDescription: 'DevOps / Infrastructure', color: '', buttonColor: ''},
        {statusCode: 82, statusDescription: 'Operations', color: '', buttonColor: ''},
        {statusCode: 83, statusDescription: 'Administrative Support', color: '', buttonColor: ''},
        {statusCode: 84, statusDescription: 'Supervisor', color: '', buttonColor: ''},
        {statusCode: 85, statusDescription: 'Supervisor', color: '', buttonColor: ''},
        {statusCode: 86, statusDescription: 'Confirmations', color: '', buttonColor: ''},
    ],
    description_colors: [
        {statusDescription: 'In Progress', color: 'orange--text'},
        {statusDescription: 'Completed', color: 'green--text'}
    ],
    salary_types: [
        {salaryType: 1, name: 'Monthly'},
        {salaryType: 2, name: 'Hourly'},
        {salaryType: 3, name: 'Daily'}
    ],
    contribution_schedule_types: [
        {contributionSchedule: 1, name: 'Per Cutoff'},
        {contributionSchedule: 2, name: 'Monthly'}
    ]
}

export default common_data